<script setup lang="ts">
withDefaults(defineProps<{
  showText?: boolean
  text?: string
  size?: 'default' | 'large'
}>(), {
  showText: true,
  text: '加载中...',
  size: 'default'
})
</script>

<template>
  <span
    class="loading-indicator"
    :class="{ 'is-icon-only': !showText, 'is-large': size === 'large' }"
    role="status"
    :aria-label="showText ? undefined : text"
  >
    <span class="loading-indicator-ring" aria-hidden="true" />
    <span v-if="showText">{{ text }}</span>
  </span>
</template>

<style scoped>
.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 32px;
  color: var(--text-soft);
  font-size: 13px;
}

.loading-indicator-ring {
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border: 2px solid color-mix(in srgb, var(--brand) 22%, transparent);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: loading-indicator-spin 0.75s linear infinite;
}

.loading-indicator.is-icon-only {
  display: inline-flex;
  min-height: 0;
  color: inherit;
  font-size: inherit;
}

.loading-indicator.is-icon-only .loading-indicator-ring {
  width: 1em;
  height: 1em;
}

.loading-indicator.is-large {
  gap: 10px;
  font-size: 15px;
}

.loading-indicator.is-large .loading-indicator-ring {
  width: 24px;
  height: 24px;
}

@keyframes loading-indicator-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading-indicator-ring {
    animation: none;
  }
}
</style>
